const MONTHLY_COGS_UPDATE = 'bfb/monthly_cogs/MONTHLY_COGS_UPDATE';

export default {
  MONTHLY_COGS_UPDATE,
};
